var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu"},_vm._l((_vm.list),function(val,key){return _c('router-link',{key:key,staticClass:"cell",class:_vm.cellSize(),attrs:{"to":_vm.search(val)}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(val.gc_thumb),expression:"val.gc_thumb"}]})])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }